/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CreateUserTaskRequest,
  CreateUserTasksBulkRequest,
  CreateUserTasksBulkResponse,
  GetUserTaskResponse,
  PaginatedResultOfGetUserTaskResponse,
  ProblemDetails,
  Result,
  SetUserTaskStatusRequest,
  UpdateUserTaskRequest,
  UserTaskStatus,
  ValidationProblemDetails,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreateUserTaskRequestFromJSON,
    CreateUserTaskRequestToJSON,
    CreateUserTasksBulkRequestFromJSON,
    CreateUserTasksBulkRequestToJSON,
    CreateUserTasksBulkResponseFromJSON,
    CreateUserTasksBulkResponseToJSON,
    GetUserTaskResponseFromJSON,
    GetUserTaskResponseToJSON,
    PaginatedResultOfGetUserTaskResponseFromJSON,
    PaginatedResultOfGetUserTaskResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ResultFromJSON,
    ResultToJSON,
    SetUserTaskStatusRequestFromJSON,
    SetUserTaskStatusRequestToJSON,
    UpdateUserTaskRequestFromJSON,
    UpdateUserTaskRequestToJSON,
    UserTaskStatusFromJSON,
    UserTaskStatusToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface ApiUserTasksBulkPostRequest {
    createUserTasksBulkRequest: CreateUserTasksBulkRequest;
    xTenantID?: number;
}

export interface ApiUserTasksGetRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    status?: UserTaskStatus;
    overdue?: boolean;
    xTenantID?: number;
}

export interface ApiUserTasksIdDeleteRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiUserTasksIdGetRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiUserTasksIdPutRequest {
    id: string;
    updateUserTaskRequest: UpdateUserTaskRequest;
    xTenantID?: number;
}

export interface ApiUserTasksIdStatusPutRequest {
    id: string;
    setUserTaskStatusRequest: SetUserTaskStatusRequest;
    xTenantID?: number;
}

export interface ApiUserTasksPostRequest {
    createUserTaskRequest: CreateUserTaskRequest;
    xTenantID?: number;
}

export interface ApiUserTasksTenantGetRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    assigneeUserId?: ApiUserTasksGetPageParameter;
    status?: UserTaskStatus;
    overdue?: boolean;
    xTenantID?: number;
}

/**
 * 
 */
export class UserTasksApi extends runtime.BaseAPI {

    /**
     * Create the same task for multiple assignees (admin)
     */
    async apiUserTasksBulkPostRaw(requestParameters: ApiUserTasksBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserTasksBulkResponse>> {
        if (requestParameters['createUserTasksBulkRequest'] == null) {
            throw new runtime.RequiredError(
                'createUserTasksBulkRequest',
                'Required parameter "createUserTasksBulkRequest" was null or undefined when calling apiUserTasksBulkPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-tasks/bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserTasksBulkRequestToJSON(requestParameters['createUserTasksBulkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserTasksBulkResponseFromJSON(jsonValue));
    }

    /**
     * Create the same task for multiple assignees (admin)
     */
    async apiUserTasksBulkPost(requestParameters: ApiUserTasksBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserTasksBulkResponse> {
        const response = await this.apiUserTasksBulkPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tasks assigned to the current user
     */
    async apiUserTasksGetRaw(requestParameters: ApiUserTasksGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetUserTaskResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['overdue'] != null) {
            queryParameters['overdue'] = requestParameters['overdue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-tasks`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetUserTaskResponseFromJSON(jsonValue));
    }

    /**
     * Get tasks assigned to the current user
     */
    async apiUserTasksGet(requestParameters: ApiUserTasksGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetUserTaskResponse> {
        const response = await this.apiUserTasksGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a completed or cancelled user task (admin)
     */
    async apiUserTasksIdDeleteRaw(requestParameters: ApiUserTasksIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserTasksIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-tasks/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a completed or cancelled user task (admin)
     */
    async apiUserTasksIdDelete(requestParameters: ApiUserTasksIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserTasksIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get an assigned user task
     */
    async apiUserTasksIdGetRaw(requestParameters: ApiUserTasksIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserTaskResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserTasksIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-tasks/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserTaskResponseFromJSON(jsonValue));
    }

    /**
     * Get an assigned user task
     */
    async apiUserTasksIdGet(requestParameters: ApiUserTasksIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserTaskResponse> {
        const response = await this.apiUserTasksIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change a user task assignee and/or status (admin)
     */
    async apiUserTasksIdPutRaw(requestParameters: ApiUserTasksIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserTasksIdPut().'
            );
        }

        if (requestParameters['updateUserTaskRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserTaskRequest',
                'Required parameter "updateUserTaskRequest" was null or undefined when calling apiUserTasksIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-tasks/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserTaskRequestToJSON(requestParameters['updateUserTaskRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Change a user task assignee and/or status (admin)
     */
    async apiUserTasksIdPut(requestParameters: ApiUserTasksIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserTasksIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Update a user task status
     */
    async apiUserTasksIdStatusPutRaw(requestParameters: ApiUserTasksIdStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserTasksIdStatusPut().'
            );
        }

        if (requestParameters['setUserTaskStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'setUserTaskStatusRequest',
                'Required parameter "setUserTaskStatusRequest" was null or undefined when calling apiUserTasksIdStatusPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-tasks/{id}/status`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetUserTaskStatusRequestToJSON(requestParameters['setUserTaskStatusRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a user task status
     */
    async apiUserTasksIdStatusPut(requestParameters: ApiUserTasksIdStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserTasksIdStatusPutRaw(requestParameters, initOverrides);
    }

    /**
     * Create an assigned user task
     */
    async apiUserTasksPostRaw(requestParameters: ApiUserTasksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createUserTaskRequest'] == null) {
            throw new runtime.RequiredError(
                'createUserTaskRequest',
                'Required parameter "createUserTaskRequest" was null or undefined when calling apiUserTasksPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-tasks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserTaskRequestToJSON(requestParameters['createUserTaskRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Create an assigned user task
     */
    async apiUserTasksPost(requestParameters: ApiUserTasksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiUserTasksPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all user tasks in the tenant (admin)
     */
    async apiUserTasksTenantGetRaw(requestParameters: ApiUserTasksTenantGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetUserTaskResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['assigneeUserId'] != null) {
            queryParameters['assigneeUserId'] = requestParameters['assigneeUserId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['overdue'] != null) {
            queryParameters['overdue'] = requestParameters['overdue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user-tasks/tenant`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetUserTaskResponseFromJSON(jsonValue));
    }

    /**
     * List all user tasks in the tenant (admin)
     */
    async apiUserTasksTenantGet(requestParameters: ApiUserTasksTenantGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetUserTaskResponse> {
        const response = await this.apiUserTasksTenantGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
